export enum PanelEnum {
    SelectedResource = "divPanel_1",
    AvailableResource = "divPanel_2",
    Attendees = "divPanel_3",
    AlternativeResources = "divPanel_4",
    FindColleague = "divPanel_5",
    FloorPlan = "divPanel_6",
    MenuBar = "divPanel_7"

}